import { delay } from 'redux-saga'
import normalize from 'jsonapi-normalizer'
import T from 'i18n-react'
import {
  takeLatest,
  take,
  fork,
  all,
  call,
  select,
  put,
} from 'redux-saga/effects'

import {
  buildUrl,
} from 'helpers/actionHelper'

import {
  getRequest,
  patch,
} from 'helpers/RequestUtil'

import {
  success,
  error,
} from 'containers/App/Notification/actions'

import {
  countSelector,
  pageSizeSelector,
  currentPageSelector,
  searchValueSelector,
  editSelector,
} from './selectors'

import {
  CHANGE_EDIT,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  CHANGE_SELECT_SITE,
  FETCH_PROJECTS,
  PATCH_PROJECTS
} from './constants'

import {
  setProjectsDialogActive,
} from 'containers/Manage/NvqualSubmissions/NvqualSubmissions/actions'

import {
  updateEdit,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updateSearchValue,
  updateSelectSite,
  clearProjectsList,
  updateProjectsList,
  fetchProjectsStart,
  fetchProjectsSuccess,
  fetchProjectsError,
  startFetchProjectsAsync,
  patchProjectsStart,
  patchProjectsSuccess,
  patchProjectsError,
  startPatchProjectsAsync,
} from './actions'

import {
  updateTablesAction,
} from 'containers/Entity/actions'

function* patchProjects({id, enable, ...value}) {
  try {
    yield put(startPatchProjectsAsync())
    yield put(patchProjectsStart())
    const data = yield call(
      patch,
      id,
      'sites',
      { enable: !enable },
      '/api/fulcrum/partner/sites'
    )
    const normalized = {
      result: { sites: [id] },
      entities: { sites: { [id]: { id, enable: !enable, ...value } } }
    }
    yield put(updateTablesAction(normalized))
    yield put(patchProjectsSuccess())
    yield put(success(T.translate(
      'pages.admin.partnerSites.notification.post_success',
      {
        name: value.name,
        status: !enable ? 'Enabled' : 'Disabled'
      }
    )))
    return data
  } catch(err) {
    yield put(patchProjectsError(error))
    yield put(error(T.translate(
      'pages.admin.partnerSites.notification.post_error',
      {
        name: value.name
      }
    )))
  }
}

function* fetchProjects(url) {
  try {
    yield put(startFetchProjectsAsync())
    yield put(fetchProjectsStart())
    const data = yield call(
      getRequest,
      url
    )
    const normalized = normalize(data)
    yield put(updateTablesAction(normalized))
    yield put(fetchProjectsSuccess())
    return data
  } catch(error) {
    yield put(fetchProjectsError(error))
  }
}

function* handlePatchProjects(action) {
  const { value } = action
  yield call(patchProjects, value)
}

function* handleFetchProjects() {
  let params = []
  yield call(delay, 500)
  const page = yield select(currentPageSelector)
  const size = yield select(pageSizeSelector)
  const search = yield select(searchValueSelector)

  if (search)
    params = [...params, { type: 'search', value: search }]

  const url = buildUrl('/api/fulcrum/manage/nvquals/nvqual_outstanding_project_views', ...params)
    .concat(`&page[number]=${page}&page[size]=${size}`)

  const data = yield call(fetchProjects, url)
  const normalized = normalize(data)
  const { result: { nvqual_outstanding_project_views : list } } = normalized
  yield put(updateCountSize(data.meta.totalCount))
  yield put(updateProjectsList(list ? list : []))
}

function* handleChangePageSize(action) {
  const { size } = action
  const page = yield select(currentPageSelector)
  const prevSize = yield select(pageSizeSelector)
  let newPage = Math.floor((page - 1) * prevSize / size)
  newPage = (newPage > 0)
    ? newPage
    : newPage + 1

  yield put(updatePageSize(size))
  yield put(updateCurrentPage(newPage))
  yield fork(handleFetchProjects)
}

function* handleChangeCurrentPage(action) {
  const { value } = action
  const page = yield select(currentPageSelector)
  yield put(updateCurrentPage(page + value))
  yield fork(handleFetchProjects)
}

function* handleSearchChange(action) {
  const { value } = action
  yield put(updateCurrentPage(1))
  yield put(clearProjectsList())
  yield put(updateSearchValue(value))
  yield fork(handleFetchProjects)
}

// function* handleChangeSelectSite(action) {
//   const { id } = action
//   yield put(updateSelectSite(id))
//   yield put(setProjectsDialogActive())
//   yield put(updateProjectsId(id))
// }

function* handleChangeEdit(action) {
  const { enable } = action
  yield put(updateCurrentPage(1))
  yield put(updateEdit(enable))
  yield put(clearProjectsList())
  yield fork(handleFetchProjects)
}

// function* watchChangeSelectSite() {
//   yield takeLatest(CHANGE_SELECT_SITE, handleChangeSelectSite)
// }

function* watchPatchProjects() {
  yield takeLatest(PATCH_PROJECTS, handlePatchProjects)
}

function* watchFetchProjects() {
  yield takeLatest(FETCH_PROJECTS, handleFetchProjects)
}

function* watchChangePageSize() {
  yield takeLatest(CHANGE_PAGE_SIZE, handleChangePageSize)
}

function* watchChangeCurrentPage() {
  yield takeLatest(CHANGE_CURRENT_PAGE, handleChangeCurrentPage)
}

function* watchSearchChange() {
  yield takeLatest(CHANGE_SEARCH_VALUE, handleSearchChange)
}

function* watchChangeEdit() {
  yield takeLatest(CHANGE_EDIT, handleChangeEdit)
}

function* loadSagas() {
  yield all([
    fork(watchFetchProjects),
    fork(watchChangePageSize),
    fork(watchChangeCurrentPage),
    fork(watchSearchChange),
    fork(watchPatchProjects),
    // fork(watchChangeSelectSite),
    // fork(watchChangeEdit)
  ])
}

export default loadSagas
